// One place that decides which map backgrounds every map screen uses.
//
// CARTO's basemaps (basemaps.cartocdn.com) started demanding a paid API key,
// so their tiles now render as a repeating "API KEY REQUIRED" wallpaper.
// Every map reads its backgrounds from here instead. Esri's ArcGIS Online
// basemaps are free for this use and need no key and no account, so a future
// provider change is a one-line edit in this file, not a hunt across screens.

export const LIGHT_BASE = {
  name: 'Light',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
  attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a>',
};

export const STREETS_BASE = {
  name: 'Streets',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, OpenStreetMap contributors',
};

export const DARK_BASE = {
  name: 'Dark',
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
  attribution: 'Tiles &copy; <a href="https://www.esri.com/">Esri</a>',
};

export const BASE_LAYERS = [LIGHT_BASE, STREETS_BASE, DARK_BASE];
